import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "edit--no-fill",
  "use": "edit--no-fill-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol viewBox=\"0 0 25 25\" xmlns=\"http://www.w3.org/2000/svg\" id=\"edit--no-fill\">\n<path d=\"M0 20.2799V24.3333C0 24.7066 0.293333 24.9999 0.666667 24.9999H4.72C4.89333 24.9999 5.06667 24.9333 5.18667 24.7999L19.7467 10.2532L14.7467 5.25325L0.2 19.7999C0.0666668 19.9332 0 20.0932 0 20.2799ZM23.6133 6.38658C24.1333 5.86658 24.1333 5.02658 23.6133 4.50658L20.4933 1.38658C19.9733 0.866582 19.1333 0.866582 18.6133 1.38658L16.1733 3.82658L21.1733 8.82658L23.6133 6.38658Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol